import React, { Component, useEffect, useState } from 'react';
import Archive from './main/archive.jsx';
import Platform from './main/platform.jsx';
import Results from './main/results.jsx';
import Analysis from './main/analysis.jsx';
import * as d3 from "d3";

function Main (props) {

    const session = '9'
    const [view, setView] = useState('archive');

    useEffect(() => {
    })

    return (
        <div id="main">
            <div id="header">
                <p className="nav" id="header_logo" style={{pointerEvents: 'none'}}>
                    NONB<span style={{fontFamily: 'Arimo', fontWeight: 500}}>AI</span>NARY
                    <span className="hidemobile" style={{fontFamily: 'Cooper', marginLeft: 60}}>How Does AI Depict Gender?</span>
                    </p>
                <div id="header_nav">
                    <p className={view === 'archive' ? "nav nav_active" : "nav"} onClick={() => setView('archive')}>Archive</p>
                    <p className={view === 'platform' ? "nav nav_active" : "nav"} onClick={() => setView('platform')}>Workshop</p>
                    {/* <p className={view === 'results' ? "nav nav_active" : "nav"} onClick={() => setView('results')}>Results</p>
                    <p className={view === 'results' ? "nav nav_active" : "nav"} onClick={() => setView('analysis')}>Analysis</p> */}
                </div>
            </div>

            {view === 'archive' && (<Archive />)}
            {view === 'platform' && (
                <Platform 
                    session={session}
                />
            )}
            {view === 'results' && (
                <Results 
                    session={session}
                />
            )}
            {view === 'analysis' && (
                <Analysis
                />
            )}
        </div>
    )
}

export default Main;